import { PropsWithChildren } from "react";

export const LoanApplicationForm = (props: PropsWithChildren) => {
  return (
    <div className="container-form">
      {props.children}
    </div>
  );
};
